import { apiCall, apiCallAdmin, apiCallGeneric } from "../../services/api-service.js";

const apiVehicleUrl = process.env.REACT_APP_VEHICLE_API_URL;

export const getGateListApi = async () => {
  return await apiCall("GET", `gate/autosuggestion`);
};

export const getEnabledFieldApi = async (data) => {
  const response = await apiCall("POST", `get_fields`, data);
  return response.data;
};
export const getReasonApi = async (id) => {
  const response = await apiCall("GET", `get_vehicle_reason/${id}`);
  return response.data;
};

export const gateInfoApi = async (data) => {
  const response = await apiCall("POST", `getGateInfo`, data);
  return response.data;
};

export const getLocation = async (gateId) => {
  const response = await apiCall("GET", `gate_location_details/${gateId}`);
  return response.data;
};

export const getResponsiblePersonApi = async (gateId) => {
  const response = await apiCall("GET", `get_responsible_person/${gateId}`);
  return response.data;
};

export const getCheckList = async (locationId, type) => {
  const response = await apiCall("GET", `checklist/autosuggestion?type=${type}&location_id=${locationId}`);
  return response.data;
};

export const getMobileNumberBasedVisitor = async (mobileNumber, type) => {
  const response = await apiCall("GET", `mobile?mobilenumber=${mobileNumber}&type=${type}`);
  return response.data;
};

export const sendOTPApi = async (data) => {
  const response = await apiCallAdmin("POST", `sent_otp`, data);
  return response.data;
};

export const getVehicleBasedVisitor = async (data) => {
  const response = await apiCall("POST", `get_vehicle_details`, data);
  return response.data;
};

export const verifyOTPApi = async (data) => {
  const response = await apiCallAdmin("POST", `verify_otp`, data);
  return response.data;
};

export const createVisitorApi = async (data) => {
  return await apiCall("POST", `visitors`, data);
};

export const updateVisitorApi = async (data) => {
  return await apiCall("PUT", `visitors`, data);
};

export const getVisitorDetailsApi = async (visitorId) => {
  const response = await apiCall("GET", `visitors/get/${visitorId}`);
  return response.data;
};
export const getHistoryListApi = async (visitorId, type) => {
  const response = await apiCall("GET", `get_transaction_history?type=${type}&id=${visitorId}`);
  return response.data;
};

export const checkListFailsUpdateApi = async (id, status, type) => {
  return await apiCall("POST", `approve_failedcheck`, { id, status, type });
};

export const getLocationFilterApi = async () => {
  const response = await apiCallAdmin("GET", `get_location`);
  return response.data;
};

export const getDepartmentFilterApi = async () => {
  const response = await apiCallAdmin("GET", `get_department`);
  return response.data;
};

export const gateInApprovedCheckListApi = async (id, type) => {
  return await apiCall("POST", `failedCheckUpdate`, { id, type });
};
export const vehicleGateInApprovedCheckListApi = async (id, type, invoice, remarks) => {
  return await apiCall("POST", `failedCheckUpdate`, { id, type, invoice_number: invoice, remarks });
};

export const uploadGateInOutAttachmentApi = async (id, data) => {
  return await apiCall("PUT", `transaction_images_update/${id}`, data);
};
export const gateOutApi = async (data) => {
  return await apiCall("POST", `visitors/gate_out`, data);
};

export const queueStatusUpdateApi = async (data) => {
  return await apiCall("POST", `queueStatusUpdate`, data);
};

export const scheduleStatusUpdateApi = async (data) => {
  return await apiCall("POST", `visitors/schedulestatusupdate`, data);
};

export const getFailedCheckList = async (id, type) => {
  const response = await apiCall("GET", `get_trans_checklist/${id}/${type}`);
  return response.data;
};

export const updateExpiryDateApi = async (id, data) => {
  return await apiCall("POST", `visitors/update_expiry/${id}`, data);
};

export const reportAnIssueApi = async (data) => {
  return await apiCallAdmin("POST", `report_issue`, data);
};

export const getReportIssueTypeApi = async () => {
  const response = await apiCallAdmin("GET", `get_issue_type`);
  return response.data;
};

export const getEVehicleInfoApi = async (data) => {
  const response = await apiCallGeneric("POST", apiVehicleUrl + `get_vehicle_info`, data);
  return response.data;
};

export const getEDriverInfoApi = async (data) => {
  const response = await apiCallGeneric("POST", apiVehicleUrl + `get_driver_info`, data);
  return response.data;
};

export const saveVehicleApi = async (data) => {
  const response = await apiCallGeneric("POST", apiVehicleUrl + `save_vehicle`, data);
  return response.data;
};
